import { defaultHttpClient } from 'shared/src/api/httpClient';

type DeleteAddressParams = {
  sno: number;
};

/**
 * - 배송지 삭제
 * - `DELETE /members/me/addresses/{sno}/`
 */
export const deleteAddress = ({ sno }: DeleteAddressParams) => {
  return defaultHttpClient
    .request<void>({
      method: 'DELETE',
      url: `/api/v2/members/me/addresses/${sno}/`,
    })
    .then(r => r.data);
};
